class CountrySelectorModal {
  constructor(sectionId) {
    this.modal = document.getElementById(`PopupModal-${sectionId}`);
    this.localCountryCode = localStorage.getItem('country_code');

    this.initModal();
    this.syncLocalCountryCode();
  }

  initModal() {
    if (!this.modal || this.localCountryCode) return;

    this.setSuggestions();
    this.modal.show();

    const countryCodeInput = this.modal.querySelector('input[name="country_code"]');

    if (!countryCodeInput) return;

    this.setInputObserver(countryCodeInput);

    document.body.addEventListener('modalClosed', () => {
      localStorage.setItem('country_code', countryCodeInput.value);
    }, { once: true });
  }

  syncLocalCountryCode() {
    if (this.localCountryCode && this.localCountryCode !== Shopify.country) {
      localStorage.setItem('country_code', Shopify.country);
    }
  }

  setInputObserver(input) {
    if (input) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            localStorage.setItem('country_code', input.value);
            this.hasUserInteracted = true;
          }
        });
      });

      observer.observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });
    }
  }

  async setSuggestions() {
    const suggestionsContainer = this.modal.querySelector('[data-suggestions]');
    const suggestionsLink = this.modal.querySelector('[data-suggestion-link]');
    const suggestions = await this.fetchSuggestions();

    if (suggestionsContainer &&
        suggestionsLink &&
        suggestions.suggestions.length > 0) {
      suggestionsContainer.removeAttribute('hidden');
      suggestionsLink.setAttribute('data-value', suggestions.suggestions[0].parts.country.handle);
      suggestionsLink.querySelector('.country').textContent = suggestions.suggestions[0].parts.country.name;
    }
  }

  async fetchSuggestions() {
    try {
      const response = await fetch(
        window.Shopify.routes.root
          + 'browsing_context_suggestions.json'
          + '?country[enabled]=true'
      );

      return await response.json();
    } catch (error) {
      console.error('Error fetching suggestions:', error);
    }
  }
}
